import { render, staticRenderFns } from "./profileOwner.vue?vue&type=template&id=f267727e&scoped=true"
import script from "./profileOwner.vue?vue&type=script&lang=js"
export * from "./profileOwner.vue?vue&type=script&lang=js"
import style0 from "./profileOwner.vue?vue&type=style&index=0&id=f267727e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f267727e",
  null
  
)

export default component.exports